import { API, axiosInstance } from "lib";

export const uploadFiles = (data = {}) => {
  return axiosInstance
    .post(API.COMMON_DROPDOWN + "upload_file", data, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        return err?.response?.data
      }
     
    });
};
